import React, { Component } from "react";
import { connect } from "react-redux";
import {
  changeProductVariant,
  getProductType,
} from "../redux/creators/threekitCreators";
import { updateModelOptions } from "../redux/creators/fabricCreators";
import { getImageIds } from "../helpers/fabricHelpers";
import { updateDimensions } from "../redux/reducers/playerSlice";
import {
  setAddToCartDisabled,
  setLoading,
} from "../redux/reducers/threekitSlice";
import { getDimensions, isApparel } from "../helpers/productHelpers";
import { default as VariantSelectOption } from "./VariantSelectOption";
import { default as VariantColorOption } from "./VariantColorOption";
import { default as ApparelFitLinks } from "./ApparelFitLinks";
import "../../../css/variant.css";
import styled from "styled-components";

class VariantOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentOptions: {},
    };
  }

  componentDidMount() {
    this.setInitialProduct();
  }

  componentDidUpdate() {}

  setInitialProduct = () => {
    const options = window.product.options;
    const variants = this.props.selectedProduct.variants;
    const firstVariant = variants.find((variant) => variant.available) || null;

    // Out of stock message if no available variant
    if (firstVariant === null) {
      const div = document.getElementById("outOfStock");
      div.classList.add("outOfStock-visible");
      div.innerHTML = "Sorry, this product is out of stock.";

      // Else, set product
    } else {
      this.state.currentOptions = Object.fromEntries(
        options.map((option, index) => [option, firstVariant.options[index]])
      );
      // Stickers and Magnets need proper dimensions set on load
      if (
        ["sticker", "metal-magnet", "wood", "promo-magnet"].includes(
          this.props.productType
        )
      ) {
        this.changeProduct(firstVariant);
      } else {
        this.props.changeProductVariant(firstVariant);
      }
    }
  };

  handleProductChange = (value, option) => {
    let selectedValue = value;
    let selectedOption = option;

    // Values from select come as an object
    if (typeof value !== "string") {
      selectedValue = value.value;
    }
    if (typeof option !== "string") {
      selectedOption = option.name;
    }

    this.state.currentOptions[selectedOption] = selectedValue;

    let newVariant = this.props.selectedProduct.variants.find((variant) => {
      const values = Object.values(this.state.currentOptions);
      return JSON.stringify(variant.options) == JSON.stringify(values);
    });

    this.changeProduct(newVariant);
  };

  async changeProduct(variant) {
    // Stickers and metal magnets use variants to change dimensions
    const changeDimensions = [
      "sticker",
      "metal-magnet",
      "wood",
      "promo-magnet",
    ].includes(this.props.productType);
    if (changeDimensions) {
      const [canHeight, canWidth] = getDimensions(variant);
      this.props.updateDimensions({ canHeight, canWidth });
    }

    this.props.changeProductVariant(variant);
    await this.props.updateModelOptions();
  }

  render() {
    return (
      <VariantOptionsContainer>
        <div id="outOfStock"></div>
        {isApparel(this.props.productType) && (
          <div>
            <ApparelFitLinks
              productType={this.props.productType}
              imageIds={this.props.imageIds}
            />
          </div>
        )}

        {this.props.variantOptions.map((option) => {
          console.log(option);
          return option.name == "Color" ? (
            <VariantColorOption
              key={option.name}
              option={option}
              selected={this.state.currentOptions["Color"]}
              handleProductChange={this.handleProductChange}
            />
          ) : (
            <VariantSelectOption
              key={option.name}
              option={option}
              handleProductChange={this.handleProductChange}
            />
          );
        })}
      </VariantOptionsContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  variantOptions: state.threekit.variantOptions,
  selectedProduct: state.threekit.selectedProduct,
  productType: getProductType(state),
  imageIds: getImageIds(state),
});
export default connect(mapStateToProps, {
  changeProductVariant,
  updateModelOptions,
  updateDimensions,
  setAddToCartDisabled,
})(VariantOptions);

const VariantOptionsContainer = styled.div`
  width: 100%;

  .outOfStock-visible {
    color: #e00425;
    font-weight: bold;
    text-align: left;
    padding: 3px 6px;
    margin-bottom: 10px;
    border: 1px solid #e00425;
  }
`;
